 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import LOVE_1 from '@/components/love_1'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML02_DEDICATION from '@/components/xhtml/02_Dedication'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML03_PART01 from '@/components/xhtml/03_Part01'
 import XHTML04_PT01_CHAPTER01 from '@/components/xhtml/04_Pt01_Chapter01'
 import XHTML05_PT01_CHAPTER02 from '@/components/xhtml/05_Pt01_Chapter02'
 import XHTML06_PT01_CHAPTER03 from '@/components/xhtml/06_Pt01_Chapter03'
 import XHTML07_PT01_CHAPTER04 from '@/components/xhtml/07_Pt01_Chapter04'
 import XHTML08_PT01_CHAPTER05 from '@/components/xhtml/08_Pt01_Chapter05'
 import XHTML09_PT01_CHAPTER06 from '@/components/xhtml/09_Pt01_Chapter06'
 import XHTML10_PT01_CHAPTER07 from '@/components/xhtml/10_Pt01_Chapter07'
 import XHTML11_PT01_CHAPTER08 from '@/components/xhtml/11_Pt01_Chapter08'
 import XHTML12_PART02 from '@/components/xhtml/12_Part02'
 import XHTML13_PT02_CHAPTER09 from '@/components/xhtml/13_Pt02_Chapter09'
 import XHTML14_PT02_CHAPTER10 from '@/components/xhtml/14_Pt02_Chapter10'
 import XHTML15_PT02_CHAPTER11 from '@/components/xhtml/15_Pt02_Chapter11'
 import XHTML16_PT02_CHAPTER12 from '@/components/xhtml/16_Pt02_Chapter12'
 import XHTML17_PT02_CHAPTER13 from '@/components/xhtml/17_Pt02_Chapter13'
 import XHTML18_PT02_CHAPTER14 from '@/components/xhtml/18_Pt02_Chapter14'
 import XHTML19_PT02_CHAPTER15 from '@/components/xhtml/19_Pt02_Chapter15'
 import XHTML20_PART03 from '@/components/xhtml/20_Part03'
 import XHTML21_PT03_CHAPTER16 from '@/components/xhtml/21_Pt03_Chapter16'
 import XHTML22_PT03_CHAPTER17 from '@/components/xhtml/22_Pt03_Chapter17'
 import XHTML23_PT03_CHAPTER18 from '@/components/xhtml/23_Pt03_Chapter18'
 import XHTML24_PT03_CHAPTER19 from '@/components/xhtml/24_Pt03_Chapter19'
 import XHTML25_PT03_CHAPTER20 from '@/components/xhtml/25_Pt03_Chapter20'
 import XHTML26_PT03_CHAPTER21 from '@/components/xhtml/26_Pt03_Chapter21'
 import XHTML27_PT03_CHAPTER22 from '@/components/xhtml/27_Pt03_Chapter22'
 import XHTML28_PT03_CHAPTER23 from '@/components/xhtml/28_Pt03_Chapter23'
 import LOVE_2 from '@/components/love_2'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLORIMAD from '@/components/xhtml/ORIM-ad'
 import XHTMLAUBA from '@/components/xhtml/auba'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/03_Part01",
 			"name" : "xhtml/03_Part01",
 			"component" : XHTML03_PART01
 		},
 		{
 			"path" : "/xhtml/04_Pt01_Chapter01",
 			"name" : "xhtml/04_Pt01_Chapter01",
 			"component" : XHTML04_PT01_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/05_Pt01_Chapter02",
 			"name" : "xhtml/05_Pt01_Chapter02",
 			"component" : XHTML05_PT01_CHAPTER02
 		},
 		{
 			"path" : "/xhtml/06_Pt01_Chapter03",
 			"name" : "xhtml/06_Pt01_Chapter03",
 			"component" : XHTML06_PT01_CHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js